import React from 'react';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { TextField, styled, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { ReturnRow } from 'types/ReturnTable';
import { useAppDispatch } from 'reducers';
import { setOneOrderSelected } from 'actions/returnProducts';
import { integer } from 'components/FieldTypes/formatters';

const AmountInputContainer = styled('div')({
  display: 'flex',
  alignItems: 'stretch',
  width: '100%',
  '& .MuiOutlinedInput-root': {
    borderRadius: 0,
  },
  '& > .MuiButton-root': {
    minWidth: 0,
    '&:not(:first-child)': {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
    },
    '&:not(:last-child)': {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },
  },
});

type Props = {
  row: ReturnRow;
};

const AmountInput: React.FC<Props> = ({ row }) => {
  const { t } = useTranslation('return');
  const dispatch = useAppDispatch();

  function changeAmount(amount: string | number) {
    dispatch(
      setOneOrderSelected(row.stableRowID, {
        ...row,
        amount: Number(integer(String(amount), String(row.amount ?? 0))),
      }),
    );
  }

  return (
    <AmountInputContainer>
      <Button
        size="small"
        variant="contained"
        color="primary"
        disableElevation
        onClick={() => changeAmount(Number(row.amount) - 1)}
        disabled={Number(row.amount) - 1 < 1}
      >
        <RemoveIcon />
      </Button>
      <TextField
        onChange={e => changeAmount(e.target.value)}
        value={row.amount}
        fullWidth
        size="small"
        variant="outlined"
        label={`${t('headings.qty')} ${row.amount} / ${row.originalAmount}`}
        data-testid="product-row-qty"
      />
      <Button
        size="small"
        variant="contained"
        color="primary"
        disableElevation
        disabled={Number(row.amount) + 1 > Number(row.originalAmount)}
        onClick={() => changeAmount(Number(row.amount) + 1)}
      >
        <AddIcon />
      </Button>
    </AmountInputContainer>
  );
};

export default AmountInput;
